import { useState, useEffect } from 'react';
import axios from 'axios';
import { getApiUrl } from '../config/api';

const useCompanies = () => {
  const [companyData, setCompanyData] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await axios.get(getApiUrl('/companies'));
        setCompanyData(response.data)
      } catch (error) {
        console.error('Failed to fetch job postings:', error);
      }
    };

    fetchCompanies();
  }, []);

  return companyData;
};

export default useCompanies;
